// extracted by mini-css-extract-plugin
export default {"PropertiesPageTabsNavigation":"PropertiesPageTabs-module__PropertiesPageTabsNavigation--x66tu"};